import { Inject, Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountService } from './account';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private router = inject(Router);
  private httpClient = inject(HttpClient);
  private subscriptionStatus: string = 'notActive';

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private accountService: AccountService
  ) {
  }

  /**
   * Получение активной подписки клиента
   * @returns
   */
  getActiveAccountSubscriptions(): Observable<AccountSubscription> {
    return new Observable(subscriber => {
      this.accountService.checkExpireToken("SubscriptionService.getActiveAccountSubscriptions").subscribe(res => {
        return this.httpClient.get<AccountSubscription>(this.baseUrl + '/v1/subscription/account', {
          headers: {
            'X-Account-Id': this.accountService.getAccountId(),
            'Authorization': 'Bearer ' + this.accountService.getAccessToken()
          },
        })
          .subscribe(data => {
            subscriber.next(data);
            subscriber.complete();
          });
      });
    })
  }

  /**
   * Получение активного плана подписки
   * @returns
   */
  getActiveSubscriptionPlan(): Observable<SubscriptionPlan> {
    var res = this.httpClient.get<SubscriptionPlan>(this.baseUrl + '/v1/subscription/plan/active', {
      headers: {
        'X-Account-Id': this.accountService.getAccountId(),
        'Authorization': 'Bearer ' + this.accountService.getAccessToken()
      },
    });

    return res;
  }

  /**
   * Отмена подписки
   * @returns
   */
  cancelSubscription(): Observable<CreatePaymentResponse> {
    return new Observable(subscriber => {
      this.accountService.checkExpireToken("SubscriptionService.cancelSubscription").subscribe(res => {
        return this.httpClient.post<CreatePaymentResponse>(this.baseUrl + '/v1/subscription/account/cancel',
          null,
          {
            headers: {
              'X-Account-Id': this.accountService.getAccountId(),
              'Authorization': 'Bearer ' + this.accountService.getAccessToken()
            },
          })
          .subscribe(data => {
            subscriber.next(data);
            subscriber.complete();
          });
      }
      );
    })
  }

  setSubscriptionStatus(status: string) {
    this.subscriptionStatus = status;
  }

  getSubscriptionStatus() {
    return this.subscriptionStatus;
  }
}
